<template>
  <div class="brand-intro">
    <div class="logo">
      <img :src="BP_LOGO" alt="Logo" class="logo-top" />
    </div>
    <div class="title-initial text-center">
      <span>A <span class="bp-text">BP</span> tem</span>
      <span class="border-bottom-text">solução.</span>
    </div>
  </div>
</template>

<script>
import { BP_LOGO } from '../../shared/global';
export default {
  name: 'BrandIntro',
  data() {
    return {
      BP_LOGO,
    };
  },
};
</script>

<style scoped>
.brand-intro {
  background-color: #ffffff;
  width: 100%;
  height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3rem;
}

.logo-top {
  width: 120px;
}

.title-initial {
  display: flex;
  flex-direction: column;
  line-height: 3.25rem;
  color: #000038;
  font-size: 3rem;
  font-weight: 700;
  font-family: 'montserratbold', sans-serif;
  padding-top: 8px;
  align-items: center;
}

.border-bottom-text {
  border-bottom: 2px solid #2b50bb;
  width: fit-content;
  padding-bottom: 10px;
}

.bp-text {
  font-family: 'montserratextrabolditalic', sans-serif;
}
</style>
